import "./AdjuntosCard.css";

export default function AdjuntosCard({
  campaign,
  setCampaign,
}) {
  const attachments = Array.isArray(campaign.attachments)
    ? campaign.attachments
    : [];

  function handleFilesSelected(event) {
    const files = Array.from(event.target.files || []);

    if (files.length === 0) return;

    setCampaign((prev) => ({
      ...prev,
      attachments: [...attachments, ...files],
    }));

    event.target.value = "";
  }

  function removeAttachment(index) {
    setCampaign((prev) => ({
      ...prev,
      attachments: prev.attachments.filter((_, i) => i !== index),
    }));
  }

  function formatSize(bytes) {
    if (!bytes) return "0 KB";

    if (bytes < 1024 * 1024) {
      return `${(bytes / 1024).toFixed(1)} KB`;
    }

    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  }

  return (
    <div className="campaign-card">
      <div className="campaign-card-header">
        <div className="campaign-card-icon">
          <i className="fa-solid fa-paperclip"></i>
        </div>

        <div>
          <h2>Archivos adjuntos</h2>
          <p>
            Puedes añadir documentos, imágenes o PDFs que se enviarán junto al
            correo.
          </p>
        </div>
      </div>

      <label className="attachment-upload">
        <input
          type="file"
          multiple
          onChange={handleFilesSelected}
          style={{ display: "none" }}
        />

        <i className="fa-solid fa-cloud-arrow-up"></i>

        <span>Seleccionar archivos</span>
      </label>

      {attachments.length === 0 ? (
        <div className="attachment-empty">
          <i className="fa-solid fa-folder-open"></i>

          <p>No hay archivos adjuntos.</p>
        </div>
      ) : (
        <div className="attachment-list">
          {attachments.map((file, index) => (
            <div
              key={`${file.name}-${index}`}
              className="attachment-item"
            >
              <div className="attachment-info">
                <i className="fa-solid fa-file"></i>

                <div>
                  <strong>{file.name}</strong>

                  <small>{formatSize(file.size)}</small>
                </div>
              </div>

              <button
                type="button"
                className="attachment-remove"
                onClick={() => removeAttachment(index)}
              >
                <i className="fa-solid fa-trash"></i>
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}